import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiHttpClient {
  baseUrl = environment.baseUrl + '/api/';
  private http = inject(HttpClient);

  public get<T>(url: string, options?: object): Observable<T> {
    url = this.baseUrl + url;
    return this.http.get<T>(url, options);
  }

  public post<T>(url: string, body: unknown, options?: object): Observable<T> {
    url = this.baseUrl + url;
    return this.http.post<T>(url, body, options);
  }

  public put<T>(url: string, body: unknown, options?: object): Observable<T> {
    url = this.baseUrl + url;
    return this.http.put<T>(url, body, options);
  }

  public delete<T>(url: string, options?: object): Observable<T> {
    url = this.baseUrl + url;
    return this.http.delete<T>(url, options);
  }
}
